import React from 'react';
import moment from 'moment';
import { Modal } from 'hyperdb-utils';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { ConfirmModal } from 'hyperdb-utils';
import SeasonalConditionsForm from './SeasonalConditionsForm';
import ModalSeasonsConflict from './ModalSeasonsConflict';

class SeasonalConditionsEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const props = this.props;
    return (
      <fieldset>
        <div className="box-header">
          <span>
            <b>Seasons</b>
            &nbsp;
            <button type="button" className="btn btn-xs btn-primary" onClick={ this.handleToggleModal.bind(this, true, -1) }>Add</button>
          </span>
        </div>
        <div className="table-responsive no-padding">
          <table className="table table-hover table-striped table-bordered table-responsive">
            <thead>
              <tr>
                <th>From</th>
                <th>To</th>
                <th>Min. stay</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                (props.conditions).map((condition, i) => {
                  if (!shouldDisplay(condition) || condition.deleted) return null;
                  return (
                    <tr key={ i }>
                      <td>{ condition.date_start }</td>
                      <td>{ condition.date_end }</td>
                      <td>{ condition.min_stay }</td>
                      <td>
                        <DropdownButton title={ <span><i className="fas fa-caret" /> Actions</span> } pullRight bsSize="small" id="Menu actions">
                          <MenuItem onClick={ this.handleToggleModal.bind(this, true, i) }>Edit</MenuItem>
                          <MenuItem onClick={ this.handleOnDupliacte.bind(this, i) }>Duplicate</MenuItem>
                          <MenuItem onClick={ this.handleToggleModalDelete.bind(this, i) }>Delete</MenuItem>
                        </DropdownButton>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        {
          this.state.showModalSeasonalConditionsForm
            ? <Modal title="Seasonal condition" onClose={ this.handleToggleModal.bind(this, false) } onAccept={ handleSubmitCondition.bind(this, this.props.onChange, false) }>
                <SeasonalConditionsForm
                  seasonalCondition={ this.state.editedSeasonalCondition }
                  onChange={ handleChangeCondition.bind(this) }
                  errorDates={ this.state.errorDates }
                />
              </Modal>
            : null
        }
        {
          this.state.showModalDeleteSeasonalCondition
            ? <ConfirmModal title="Delete seasonal condition" onClose={ this.handleToggleModalDelete.bind(this, -1)} onConfirm={ this.handleDeleteCondition.bind(this) }>
                Delete this seasonal condition ?
              </ConfirmModal>
            : null
        }
        {
          this.props.showModalConflict
            ? <ModalSeasonsConflict
                close={ this.props.toggleModalConflict.bind(this, false) }
                items={ this.props.conditions }
                indexesSeasonsInConflict={ this.props.indexesSeasonsInConflict }
                overwrite={ overwrite.bind(this, this.props.onChange) }
                fillGaps={ fillGaps.bind(this, this.props.onChange) }
              />
            : null
        }
      </fieldset>
    );
  }

  handleToggleModal(bool, indexEditedSeasonalCondition = -1) {
    const editedSeasonalCondition = bool && indexEditedSeasonalCondition !== -1
      ? { ...this.props.conditions[indexEditedSeasonalCondition] }
      : {};
    this.setState({ showModalSeasonalConditionsForm: bool, indexEditedSeasonalCondition, editedSeasonalCondition, errorDates: false });
  }
  handleOnDupliacte(index) {
    const seasonalCondition = { ...this.props.conditions[index] };
    seasonalCondition.date_start = null;
    seasonalCondition.date_end = null;
    this.setState({ showModalSeasonalConditionsForm: true, indexEditedSeasonalCondition: -1, editedSeasonalCondition: seasonalCondition, errorDates: false });
  }
  handleToggleModalDelete(indexDeleteSeasonalCondition = -1) {
    const showModalDeleteSeasonalCondition = indexDeleteSeasonalCondition !== -1;
    this.setState({ showModalDeleteSeasonalCondition, indexDeleteSeasonalCondition });
  }
  handleDeleteCondition() {
    const index = this.state.indexDeleteSeasonalCondition;
    if (index !== -1) {
      const conditions = (this.props.conditions).slice();
      conditions[index] = removeSeasonalCondition(this.props, conditions[index]);
      handleChangeSeasonalConditions(this.props.onChange, conditions);
    }
    this.handleToggleModalDelete(-1);
  }
};

function shouldDisplay(condition) {
  if (!condition.date_start || !condition.date_end) return true;
  const start = moment().startOf('year').format('YYYY-MM-DD');
  return condition.date_end >= start;
}
function sortedSeasonalConditions(conditions) {
  return (conditions).slice().sort((a, b) => {
    return (a.date_start || '').localeCompare(b.date_start || '');
  });
}
function hasLOS(condition) {
  return (condition.conditions_for_day_of_week || []).length > 0;
}
function hasEGP(condition) {
  return (condition.extra_for_extra_guests || []).length > 0;
}

export function handleChangeCondition(attributeName, field) {
  const { name, value } = field;
  const editedSeasonalCondition = { ...this.state.editedSeasonalCondition, [attributeName]: value };
  this.setState({ editedSeasonalCondition });
}
export function handleSubmitCondition(onChangeConditions, fromCalendar = false) {
  const conditions = (this.props.conditions).slice();
  const { editedSeasonalCondition, indexEditedSeasonalCondition } = this.state;
  if (editedSeasonalCondition.date_start && editedSeasonalCondition.date_end && editedSeasonalCondition.min_stay) {
    // Dates correct
    if (moment(editedSeasonalCondition.date_end).isSameOrAfter(editedSeasonalCondition.date_start)) {
      const indexesSeasonsInConflict = getIndexesSeasonsInConflict(conditions, editedSeasonalCondition, indexEditedSeasonalCondition);
      if (indexesSeasonsInConflict.length > 0) {
        // Conflict with other seasons
        const toggleModalConflict = fromCalendar ? this.props.toggleModalConflictConditions : this.props.toggleModalConflict;
        toggleModalConflict(true, indexesSeasonsInConflict);
      } else {
        // Save
        saveSeasonalCondition(this.props, conditions, editedSeasonalCondition, indexEditedSeasonalCondition);
        handleChangeSeasonalConditions(onChangeConditions, conditions);
        this.setState({ showModalSeasonalConditionsForm: false, indexEditedSeasonalCondition: -1, editedSeasonalCondition: {}, errorDates: false });
      }
    } else {
      // Error dates
      this.setState({ errorDates: true });
    }
  }
}

export function overwrite(onChangeConditions) {
  const props = this.props;
  const conditions = props.conditions.slice();
  const editedSeasonalCondition = this.state.editedSeasonalCondition;
  // Overwrite seasons
  props.indexesSeasonsInConflict.forEach(index => {
    const seasonalCondition = { ...props.conditions[index] };
    if (moment(seasonalCondition.date_end).isBetween(editedSeasonalCondition.date_start, editedSeasonalCondition.date_end, null, '[]')) {
      // Change end date
      if (moment(seasonalCondition.date_start).isBefore(editedSeasonalCondition.date_start)) {
        seasonalCondition.date_end = moment(editedSeasonalCondition.date_start).subtract(1, 'day').format('YYYY-MM-DD');
        conditions[index] = seasonalCondition;
      } else {
        // Remove season
        conditions[index] = removeSeasonalCondition(props, conditions[index]);
      }
    } else if (moment(seasonalCondition.date_start).isBetween(editedSeasonalCondition.date_start, editedSeasonalCondition.date_end, null, '[]')) {
      // Change begin date
      if (moment(seasonalCondition.date_end).isAfter(editedSeasonalCondition.date_end)) {
        seasonalCondition.date_start = moment(editedSeasonalCondition.date_end).add(1, 'day').format('YYYY-MM-DD');
        conditions[index] = seasonalCondition;
      } else {
        // Remove season
        conditions[index] = removeSeasonalCondition(props, conditions[index]);
      }
    } else {
      // Split season
      const copiedSeason = { ...seasonalCondition, date_end: moment(editedSeasonalCondition.date_start).subtract(1, 'day').format('YYYY-MM-DD') };
      saveSeasonalCondition(props, conditions, copiedSeason, -1, false);
      seasonalCondition.date_start = moment(editedSeasonalCondition.date_end).add(1, 'day').format('YYYY-MM-DD');
      conditions[index] = seasonalCondition;
    }
  });
  // Save
  saveSeasonalCondition(props, conditions, editedSeasonalCondition, this.state.indexEditedSeasonalCondition);
  handleChangeSeasonalConditions(onChangeConditions, conditions);
  this.setState({ showModalSeasonalConditionsForm: false, indexEditedSeasonalCondition: -1, editedSeasonalCondition: {}, errorDates: false });
}
export function fillGaps(onChangeConditions) {
  const props = this.props;
  const conditions = props.conditions.slice();
  const editedSeasonalCondition = this.state.editedSeasonalCondition;
  // Fill gap before first season
  const firstSeason = conditions[props.indexesSeasonsInConflict[0]];
  if (moment(editedSeasonalCondition.date_start).isBefore(firstSeason.date_start)) {
    saveSeasonalCondition(props, conditions, { ...editedSeasonalCondition, date_end: moment(firstSeason.date_start).subtract(1, 'day').format('YYYY-MM-DD') });
  }
  // Fill gap after last season
  const lastSeason = conditions[props.indexesSeasonsInConflict.slice(-1)[0]];
  if (moment(editedSeasonalCondition.date_end).isAfter(lastSeason.date_end)) {
    saveSeasonalCondition(props, conditions, { ...editedSeasonalCondition, date_start: moment(lastSeason.date_end).add(1, 'day').format('YYYY-MM-DD') });
  }
  // Fill gap between seasons
  if (props.indexesSeasonsInConflict.length >= 2) {
    let previousSeasonEndDate;
    props.indexesSeasonsInConflict.forEach(index => {
      const seasonalCondition = conditions[index];
      if (index > 0 && moment(previousSeasonEndDate).add(1, 'day').isBefore(seasonalCondition.date_start)) {
        saveSeasonalCondition(props, conditions, { ...editedSeasonalCondition, date_start: moment(previousSeasonEndDate).add(1, 'day').format('YYYY-MM-DD'), date_end: moment(seasonalCondition.date_start).subtract(1, 'day').format('YYYY-MM-DD') });
      }
      previousSeasonEndDate = seasonalCondition.date_end;
    });
  }
  // Save
  handleChangeSeasonalConditions(onChangeConditions, conditions);
  this.setState({ showModalSeasonalConditionsForm: false, indexEditedSeasonalCondition: -1, editedSeasonalCondition: {}, errorDates: false });
}

function saveSeasonalCondition(props, conditions, seasonalCondition, index = -1, setSynchronisation = true) {
  let _cond = seasonalCondition;
  if (index === -1 || index === null || index === undefined) {
    conditions.push({ ...seasonalCondition, id: conditions.length + 1 });
  } else {
    _cond = { ...conditions[index] };
    conditions[index] = seasonalCondition;
  }
  if (setSynchronisation && props.setSeasonalConditionSynchronisation) {
    props.setSeasonalConditionSynchronisation(_cond);
  }
}
function removeSeasonalCondition(props, seasonalCondition) {
  if (props.setSeasonalConditionSynchronisation) {
    props.setSeasonalConditionSynchronisation(seasonalCondition);
  }
  return { ...seasonalCondition, 'deleted': true };
}
function handleChangeSeasonalConditions(onChange, conditions) {
  onChange({ value: sortedSeasonalConditions(conditions.filter(p => !!p)) });
}

function getIndexesSeasonsInConflict(conditions, editedSeasonalCondition, indexEditedSeasonalCondition) {
  const indexes = [];
  conditions.forEach((seasonalCondition, i) => {
    if (!seasonalCondition.deleted) {
      if (indexEditedSeasonalCondition === i) {
        if (editedSeasonalCondition.date_start !== seasonalCondition.date_start && editedSeasonalCondition.date_end !== seasonalCondition.date_end) {
          if (moment(editedSeasonalCondition.date_start).isSameOrBefore(seasonalCondition.date_end) && moment(editedSeasonalCondition.date_end).isSameOrAfter(seasonalCondition.date_start)) {
            indexes.push(i);
          }
        }
      } else {
        if (moment(editedSeasonalCondition.date_start).isSameOrBefore(seasonalCondition.date_end) && moment(editedSeasonalCondition.date_end).isSameOrAfter(seasonalCondition.date_start)) {
          indexes.push(i);
        }
      }
    }
  });
  return indexes;
}

export default SeasonalConditionsEditor;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/SeasonalConditionsEditor.jsx